export type Language = 'en' | 'zh';

export const translations = {
  en: {
    title: "Domain Compare",
    subtitle: "Real-time price comparison across top global registrars. Find the best deal for your digital identity.",
    searchPlaceholder: "Search registrar or TLD...",
    batchSearchPlaceholder: "Enter multiple domains (e.g., example.com, my.net) separated by commas or newlines...",
    allTlds: "All TLDs",
    currency: "Currency",
    mode: "Mode",
    single: "Single",
    batch: "Batch",
    stats: {
      registration: "Cheapest .com Registration",
      renewal: "Cheapest .com Renewal",
      transfer: "Cheapest .com Transfer",
      foundAt: "Found at"
    },
    table: {
      tld: "TLD",
      registrar: "Registrar",
      registration: "Registration",
      renewal: "Renewal",
      transfer: "Transfer",
      value: "Value Score",
      tags: "Tags",
      action: "Action",
      visit: "Visit",
      history: "History"
    },
    sort: {
      price: "Price",
      value: "Best Value"
    },
    history: {
      title: "Price History",
      lowest: "All-time Low",
      current: "Current",
      date: "Date"
    },
    monitor: {
      title: "Domain Monitor",
      subtitle: "Track domain availability and get notified when they become available",
      addDomain: "Add Domain",
      domainPlaceholder: "Enter domain name (e.g., example)",
      selectTld: "Select TLD",
      monitoring: "Monitoring",
      available: "Available",
      notified: "Notified",
      delete: "Delete",
      noMonitors: "No domains being monitored",
      addSuccess: "Domain added to monitoring list",
      deleteSuccess: "Domain removed from monitoring list"
    },
    generator: {
      title: "Domain Generator",
      subtitle: "Generate creative domain name suggestions based on your keywords",
      keywordPlaceholder: "Enter keywords (e.g., tech, blog)",
      generate: "Generate",
      generating: "Generating...",
      available: "Available",
      taken: "Taken",
      category: "Category",
      noResults: "No suggestions generated yet",
      addToMonitor: "Monitor"
    },
    header: {
      login: "Login",
    logout: "Logout",
      points: "Points",
      trustLevel: "Trust Level"
    },
    // 添加缺失的翻译键
    profile: "Profile",
    badges: "Badges",
    login: "Login",
    logout: "Logout",
    accountInfo: "Account Information",
    pointsStats: "Points & Stats",
    username: "Username:",
    loginMethod: "Login Method:",
    trustLevelLabel: "Trust Level:",
    pointsLabel: "Points:",
    lastLogin: "Last Login:",
    actions: "Actions",
    viewDomainMonitor: "View Domain Monitor",
    domainGenerator: "Domain Generator",
    noEmail: "No email",
    pleaseLogin: "You need to be logged in to view your profile."
  },
  zh: {
    title: "域名比价",
    subtitle: "全球顶级注册商实时价格对比。为您的数字身份寻找最佳优惠。",
    searchPlaceholder: "搜索注册商或域名后缀...",
    batchSearchPlaceholder: "输入多个域名（如 example.com, my.net），用逗号或换行分隔...",
    allTlds: "所有后缀",
    currency: "货币",
    mode: "模式",
    single: "单个",
    batch: "批量",
    stats: {
      registration: ".com 最低注册价",
      renewal: ".com 最低续费价",
      transfer: ".com 最低转移价",
      foundAt: "来源："
    },
    table: {
      tld: "后缀",
      registrar: "注册商",
      registration: "注册",
      renewal: "续费",
      transfer: "转移",
      value: "性价比",
      tags: "标签",
      action: "操作",
      visit: "访问",
      history: "历史"
    },
    sort: {
      price: "价格",
      value: "性价比"
    },
    history: {
      title: "价格历史",
      lowest: "历史最低",
      current: "当前",
      date: "日期"
    },
    monitor: {
      title: "域名监控",
      subtitle: "追踪域名可用性，当域名可注册时立即通知您",
      addDomain: "添加域名",
      domainPlaceholder: "输入域名（如 example）",
      selectTld: "选择后缀",
      monitoring: "监控中",
      available: "可注册",
      notified: "已通知",
      delete: "删除",
      noMonitors: "暂无监控域名",
      addSuccess: "已添加到监控列表",
      deleteSuccess: "已从监控列表移除"
    },
    generator: {
      title: "域名生成器",
      subtitle: "根据关键词生成创意域名建议",
      keywordPlaceholder: "输入关键词（如 科技、博客）",
      generate: "生成",
      generating: "生成中...",
      available: "可注册",
      taken: "已被注册",
      category: "类别",
      noResults: "暂无生成结果",
      addToMonitor: "监控"
    },
    header: {
      login: "登录",
    logout: "退出登录",
      points: "积分",
      trustLevel: "信任等级"
    },
    // 添加缺失的翻译键
    profile: "个人资料",
    badges: "徽章",
    login: "登录",
    logout: "退出登录",
    accountInfo: "账户信息",
    pointsStats: "积分与统计",
    username: "用户名：",
    loginMethod: "登录方式：",
    trustLevelLabel: "信任等级：",
    pointsLabel: "积分：",
    lastLogin: "最后登录：",
    actions: "操作",
    viewDomainMonitor: "查看域名监控",
    domainGenerator: "域名生成器",
    noEmail: "无邮箱",
    pleaseLogin: "您需要登录才能查看个人资料。"
  }
};
